import type { Reducer } from 'react';

export type TaskChatSocketState = {
  isGameplanGenerating: boolean;
  isThinking: boolean;
  thinkingTrace?: {
    message: string;
    tool_name: string;
  };
};

export type TaskChatSocketEvent =
  | { data?: string; type: 'thinking_started' }
  | { type: 'gameplan_generation_completed' }
  | { type: 'gameplan_generation_started' }
  | { type: 'message_received' }
  | { type: 'reset' }
  | { type: 'thinking_completed' };

export const taskChatSocketInitialState: TaskChatSocketState = {
  isGameplanGenerating: false,
  isThinking: false,
};

export const taskChatSocketStateMachine: Reducer<TaskChatSocketState, TaskChatSocketEvent> = (state, event) => {
  switch (event.type) {
    case 'message_received':
      return {
        ...state,
        isGameplanGenerating: false,
      };
    case 'gameplan_generation_started':
      return {
        ...state,
        isGameplanGenerating: true,
      };
    case 'gameplan_generation_completed':
      return {
        ...state,
        isGameplanGenerating: false,
      };
    case 'thinking_started':
      if (event.data) {
        try {
          const trace = JSON.parse(event.data) as { message: string; tool_name: string };
          if (trace && typeof trace.message === 'string' && typeof trace.tool_name === 'string') {
            return {
              ...state,
              isThinking: true,
              thinkingTrace: trace,
            };
          }
        } catch (error) {
          return {
            ...state,
            isThinking: true,
            thinkingTrace: undefined,
          };
        }
      }
      return {
        ...state,
        isThinking: true,
        thinkingTrace: undefined,
      };
    case 'thinking_completed':
      return {
        ...state,
        isThinking: false,
        thinkingTrace: undefined,
      };
    case 'reset':
      return { ...taskChatSocketInitialState };
    default:
      return state;
  }
};
